import { PureComponent } from "react";

import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";

import { type MappingStatus } from "entity/job/Job.api.types";
import { type IGeoLocation } from "entity/job/JobList/JobList.api.types";

type ResponseType = IEntityMappingData | null;
type CellType = IEntityMappingData | null;

class MapStatusCell extends PureComponent<IGridCellRenderProps<CellType>> {
    render() {
        return this.props.cellValue?.mappingStatusText ?? null;
    }
}

export interface IEntityMappingData {
    mappingStatusText: string;
    mappingStatus: MappingStatus;
    coordinates: IGeoLocation;
}

export const columnEntityMappingStatus: IClientGridColumn<ResponseType, CellType> = {
    columnType: GridColumnType.mappingStatus,
    Cell: MapStatusCell,
};
